<nav class="flex" aria-label="Breadcrumb">
  <ol role="list" class="flex flex-wrap items-center sm:space-x-4">
    <li>
      @if (homeLink()) {
        <div>
          <a [routerLink]="homeLink()" class="text-vti">
            <vti-icons [icon]="'home'" color="vti" size="5"></vti-icons>
            <span class="sr-only" i18n>Home</span>
          </a>
        </div>
      } @else {
        <vti-icons [icon]="'home'" color="vti" size="5"></vti-icons>
        <span class="sr-only" i18n>Home</span>
      }
    </li>
    <ng-content></ng-content>
  </ol>
</nav>
